import styled from "styled-components";

export const ContactWrapper = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 2% auto 2% auto;
  @media only screen and (max-width: 680px) {
    width: 100%;
  }
`;

export const ContactInput = styled.input`
  border-width: 0 0 2px 0;
  border-style: solid;
  border-color: #cbcbcb;
  background-color: transparent;
  width: 100%;
  height: 50px;
  color: #003865;
  &:focus {
    outline: none;
  }
`;

export const ContactInputLabel = styled.span`
  color: #cbcbcb;
  text-align: left;
  width: 100%;
  margin-top: 10px;
`;

export const StyledButton = styled.button`
  min-height: 60px;
  color: white;
  border: 1px solid #003865;
  border-radius: 10px;
  background-color: #003865;
  width: 100%;
  flex: ${(props) => (props.noFlex ? "none" : "1")};
  margin-top: 10%;
  &:hover {
    background-color: #00c1d4;
    border: 1px solid #00c1d4;
    cursor: pointer;
  }
  @media screen only and (max-width: 600px) {
    width: 100%;
  }
`;
